import axios from '../../utils/axiosConfig';
import config from '../../utils/Config';
import axiosraw from 'axios';

let getReportPageDate =  (reportData) => {
    return new Promise((resolve, reject) => {
        console.log(config)
        axios.post(config.basePath + 'report/getreportpagedata', reportData).then(result => {
            resolve(result)
        }).catch((err) => {

            if(err && err.response && err.response.data && err.response.data && err.response.data.message){
                reject({
                    message: err.response.data.message
                })
            } else {
                reject({
                    message: "Unable to fetch report data"
                })
            }
        })
    })
}

let getReportPageDatePDF =  (reportData, token) => {
    console.log("reportData" , reportData)
    console.log("token" , token)
    return new Promise((resolve, reject) => {
        let headerdata = {
            headers: {
                'authorization': token,
                'Content-Type': 'application/json'
            }
          }
        axiosraw.post(config.basePath + 'report/getreportpagedata', reportData, headerdata).then(result => {
            resolve(result)
        }).catch((err) => {
            reject(err)
        })
    })
}

let saveReportPageData = (reportData) => {
    return new Promise((resolve, reject) => {

        let basePath = config.basePath;

        axios.post(basePath + 'report/savereportpagedata', reportData).then(result => {
            resolve(result)
        }).catch((err) => {
            
            if(err && err.response && err.response.data && err.response.data && err.response.data.message){
                reject({
                    message: err.response.data.message
                })
            } else {
                reject({
                    message: "Unable to submit enrollment data"
                })
            }
        })
    })
}

let submitReportPageData = (reportData) => {
    return new Promise((resolve, reject) => {
        let basePath = config.basePath;

        axios.post(basePath + 'report/submitorderreport', reportData).then(result => {
            resolve(result)
        }).catch((err) => {
            
            if(err && err.response && err.response.data && err.response.data && err.response.data.message){
                reject({
                    message: err.response.data.message
                })
            } else {
                reject({
                    message: "Unable to submit enrollment data"
                })
            }
        })
    })
}



const reportService = {
    getReportPageDate,
    getReportPageDatePDF,
    saveReportPageData,
    submitReportPageData
}

export default reportService 